import { useEffect } from 'react'
import { Icon } from './Icon'
import styles from './Toast.module.css'

interface ToastProps {
  message: string
  onDismiss: () => void
  durationMs?: number
}

export function Toast({ message, onDismiss, durationMs = 2800 }: ToastProps) {
  useEffect(() => {
    const t = setTimeout(onDismiss, durationMs)
    return () => clearTimeout(t)
  }, [onDismiss, durationMs])

  return (
    <div className={styles.toast}>
      <Icon name="check_circle" size="sm" style={{ color: '#81c995' }} />
      {message}
    </div>
  )
}
